import React from 'react';
import {inject} from 'mobx-react';
import classNames from 'classnames';
import { Link } from "react-router-dom";

@inject('user')
export default class TermsOfCondition extends React.Component {

  render(){
    return(
      <div className="information">
        <div className={classNames({logged_user: this.props.user.getUser()})} >

        <div className="about-us-container newpages" >
          <div className="logo">
            <svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px"
                 viewBox="0 0 760.8 158" style={{enableBackground: 'new 0 0 760.8 158'}} >

              <g>
                <path className="st0" d="M283.7,78.9c0-10.9-2.1-21.1-6.2-30.7c-4.2-9.6-9.8-17.9-17-25c-7.2-7.1-15.6-12.7-25.2-16.9
		C225.5,2.1,215.3,0,204.4,0c-2.8,0-5.5,0.1-8.1,0.4H0v37.3l52.6-0.5h10.9V158H104V37.2h33.1c-2.2,3.4-4.1,7.1-5.7,10.9
		c-4.2,9.6-6.2,19.8-6.2,30.7c0,10.9,2.1,21.1,6.2,30.7c4.2,9.6,9.8,17.9,17,25s15.5,12.7,25.1,16.8c9.6,4.1,19.9,6.1,30.9,6.1h79.3
		V78.9L283.7,78.9z M188.8,116.4c-4.8-2.2-8.9-5.2-12.4-8.9c-3.5-3.7-6.2-8.1-8.2-13.1c-2-5-3-10.2-3-15.5c0-5.5,1-10.7,3-15.6
		c2-4.9,4.7-9.2,8.2-13c3.5-3.7,7.6-6.7,12.4-8.9c4.8-2.2,10-3.4,15.6-3.4c5.6,0,10.8,1.1,15.6,3.4c4.8,2.2,8.9,5.2,12.4,8.9
		c3.5,3.7,6.2,8,8.2,13c2,4.9,3,10.1,3,15.6c0,5.4-1,10.6-3,15.5c-2,5-4.7,9.3-8.2,13.1c-3.5,3.7-7.6,6.7-12.4,8.9
		c-4.8,2.2-10,3.4-15.6,3.4C198.8,119.8,193.6,118.6,188.8,116.4z"/>
                <path className="st1" d="M375,24.5h-16.4v45.4H352V24.5h-16.3V19H375V24.5z"/>
                <path className="st1" d="M428.8,69.9h-6.7V46.4h-25.7v23.5h-6.7V19h6.7v21.9h25.7V19h6.7V69.9z"/>
                <path className="st1" d="M476.7,46.4h-22.1v18h25.6v5.5h-32.3V19h32v5.5h-25.3v16.4h22.1V46.4z"/>
                <path className="st1" d="M514.4,49.3h-12v20.6h-6.7V19h16.9c5.7,0,10.1,1.3,13.2,3.9c3.1,2.6,4.6,6.4,4.6,11.4c0,3.2-0.9,5.9-2.6,8.3
		c-1.7,2.4-4.1,4.1-7.1,5.3l12,21.6v0.4h-7.2L514.4,49.3z M502.5,43.8h10.3c3.3,0,6-0.9,8-2.6c2-1.7,3-4,3-6.9
		c0-3.2-0.9-5.6-2.8-7.2c-1.9-1.7-4.6-2.5-8.1-2.6h-10.3V43.8z"/>
                <path className="st1" d="M575.1,56.6h-21.3L549,69.9h-6.9L561.5,19h5.9l19.5,50.9H580L575.1,56.6z M555.8,51.1h17.3l-8.7-23.8
		L555.8,51.1z"/>
                <path className="st1" d="M607.6,50v19.9h-6.7V19h18.8c5.6,0,9.9,1.4,13.1,4.3c3.2,2.8,4.7,6.6,4.7,11.3c0,4.9-1.5,8.7-4.6,11.4
		c-3.1,2.7-7.5,4-13.3,4H607.6z M607.6,44.5h12.1c3.6,0,6.3-0.8,8.3-2.5c1.9-1.7,2.9-4.1,2.9-7.3c0-3-1-5.5-2.9-7.3
		c-1.9-1.8-4.5-2.8-7.9-2.8h-12.4V44.5z"/>
                <path className="st1" d="M668.7,44.5L682,19h7.6l-17.5,31.9v19h-6.7v-19L647.8,19h7.7L668.7,44.5z"/>
                <path className="st1" d="M373.3,142H349l-5.5,15.2h-7.9l22.2-58h6.7l22.2,58h-7.8L373.3,142z M351.3,135.7H371l-9.9-27.1L351.3,135.7z"
                />
                <path className="st1" d="M444.9,138.8c-0.7,6.1-3,10.9-6.8,14.2c-3.8,3.3-8.9,5-15.2,5c-6.9,0-12.3-2.5-16.5-7.4
		c-4.1-4.9-6.2-11.5-6.2-19.7v-5.6c0-5.4,1-10.1,2.9-14.2c1.9-4.1,4.7-7.2,8.2-9.4c3.5-2.2,7.6-3.3,12.3-3.3
		c6.2,0,11.1,1.7,14.8,5.2c3.7,3.4,5.9,8.2,6.5,14.3h-7.7c-0.7-4.6-2.1-8-4.3-10.1c-2.2-2.1-5.3-3.1-9.3-3.1
		c-4.9,0-8.7,1.8-11.5,5.4c-2.8,3.6-4.2,8.8-4.2,15.4v5.6c0,6.3,1.3,11.3,3.9,15c2.6,3.7,6.3,5.6,11,5.6c4.2,0,7.5-1,9.8-2.9
		c2.3-1.9,3.8-5.3,4.5-10.1H444.9z"/>
                <path className="st1" d="M495.5,142h-24.3l-5.5,15.2h-7.9l22.2-58h6.7l22.2,58H501L495.5,142z M473.5,135.7h19.7l-9.9-27.1L473.5,135.7
		z"/>
                <path className="st1" d="M524.9,157.2v-58h16.4c5,0,9.5,1.1,13.4,3.3c3.9,2.2,6.9,5.4,9,9.5c2.1,4.1,3.2,8.8,3.2,14.2v3.7
		c0,5.5-1.1,10.3-3.2,14.4c-2.1,4.1-5.1,7.3-9,9.5c-3.9,2.2-8.5,3.3-13.7,3.4H524.9z M532.5,105.4v45.5h8c5.9,0,10.5-1.8,13.8-5.5
		c3.3-3.7,4.9-8.9,4.9-15.7v-3.4c0-6.6-1.5-11.7-4.6-15.4c-3.1-3.7-7.5-5.5-13.2-5.6H532.5z"/>
                <path className="st1" d="M619.3,130.4h-25.1v20.6h29.2v6.3h-36.9v-58H623v6.3h-28.8v18.7h25.1V130.4z"/>
                <path className="st1" d="M650.9,99.2l19,47.3l19-47.3h9.9v58h-7.6v-22.6l0.7-24.4l-19,47H667l-19-46.9l0.8,24.3v22.6h-7.6v-58H650.9z"
                />
                <path className="st1" d="M737,128.3l15.1-29.1h8.7l-20,36.4v21.6h-7.6v-21.6l-20-36.4h8.8L737,128.3z"/>
              </g>
            </svg>
          </div>
        </div>
        </div>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <strong><font color="#1a1a1a"><font face="Helvetica, sans-serif">1.
            INTRODUCTION</font></font></strong></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">1.1&nbsp;</font></font><font color="#0000ff"><u><a href="http://www.therapyacademy.ie/"><font face="Helvetica, sans-serif">http://www.therapyacademy.ie</font></a></u></font><font color="#1a1a1a"><font face="Helvetica, sans-serif">&nbsp;is
          an online platform for further learning in the area of mental health.
          The domain&nbsp;</font></font><font color="#0000ff"><u><a href="http://www.therapyacademy.ie/"><font face="Helvetica, sans-serif">http://www.therapyacademy.ie</font></a></u></font><font color="#1a1a1a"><font face="Helvetica, sans-serif">&nbsp;and
          the facilities, Website and information available thereon (our
          "Website") is owned and operated by TherapyHub Ltd, an
          Irish registered company, number 598531, having its registered office
          at Portland, Lorrha, Nenagh, Co. Tipperary. Our telephone number is
          087 6200365 and our e-mail address is&nbsp;</font></font><font color="#0000ff"><u><a href="mailto:support@therapyacademy.ie"><font face="Helvetica, sans-serif">support@therapyacademy.ie</font></a></u></font><font color="#1a1a1a"><font face="Helvetica, sans-serif">.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">1.2 Your
            usage of our Website is governed by the continuous application of
            these Terms of Service. For the purpose of these Terms of Service
            "we", "our" and "us" refers to
            TherapyHub Ltd and "you" refers to you, a registered user
            of our Website and/or any facilities, Website or information
            available thereon.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">1.3 For the
            purpose of these Terms of Service, "</font></font><strong><font color="#1a1a1a"><font face="Helvetica, sans-serif">Trainee"</font></font></strong><font color="#1a1a1a"><font face="Helvetica, sans-serif">&nbsp;means
          any individual who registers for online workshops offered by
          independent contractor providers (“</font></font><font color="#1a1a1a"><font face="Helvetica, sans-serif"><b>Providers</b></font></font><font color="#1a1a1a"><font face="Helvetica, sans-serif">”)
          who provide learning Website online via workshops (“</font></font><font color="#1a1a1a"><font face="Helvetica, sans-serif"><b>Workshops</b></font></font><font color="#1a1a1a"><font face="Helvetica, sans-serif">”).
          The Workshops can be interactive in nature as Trainees may be asked
          to complete various modules that comprise the workshops. </font></font>
        </p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif"><b>2.
            ACCEPTING THE TERMS OF SERVICE</b></font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">2.1 In order
            to use our Website you must firstly agree to these Terms of Service.
            You may not use our Website if you do not accept these Terms of
            Service.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">2.2 You can
            accept these Terms of Service by actually using our Website. You
            understand and agree that we will treat your use of our Website as
            acceptance of these Terms of Service from that point onwards.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.11in', background: '#ffffff'}}>
          <font color="#232c3b"><font face="Helvetica, sans-serif">2.3
            Additionally, if you are a “Provider”, you are also subject to
            the&nbsp;</font></font><font color="#232c3b"><font face="Helvetica, sans-serif"><Link to='/providerterms'>Provider
          Terms</Link></font></font><font color="#232c3b"><font face="Helvetica, sans-serif">,
          which are hereby incorporated by reference into these Terms. If you
          are a Provider, and there is a conflict between these Terms and the
          Provider Terms, the Provider Terms will govern.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.11in', background: '#ffffff'}}>
          <font color="#232c3b"><font face="Helvetica, sans-serif">2.4 Specific
            Obligations of Providers</font></font></p>
        <p lang="en-GB" className="western" align="JUSTIFY" style={{marginTop: '0.07in', marginBottom: '0.07in', background: '#ffffff'}}>
          <font color="#232c3b"><font face="Helvetica, sans-serif">Please
            see&nbsp;</font></font><font color="#0000ff"><font color="#232c3b"><font face="Helvetica, sans-serif"><Link to='/providerterms'>Provider
          Terms</Link></font></font></font>.</p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.11in', background: '#ffffff'}}>
          <font color="#232c3b"><font face="Helvetica, sans-serif">2.5 Specific
            Obligations of Trainees</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.11in', background: '#ffffff'}}>
          <font color="#232c3b"><font face="Helvetica, sans-serif">As a
            Trainee, you represent, warrant and covenant that:</font></font></p>

        <ol style={{listStyle: 'initial', listStylePosition: 'inside'}}>
          <li><p lang="en-GB" className="western" align="JUSTIFY" style={{marginBottom: '0in', background: '#ffffff', display: "inline"}}>
            You have
              read, understood, and agree to be bound by the pricing information
              before using the Website or registering for a Workshop.</p>
          </li><li><p lang="en-GB" className="western" align="JUSTIFY" style={{marginBottom: '0in', background: '#ffffff', display: 'inline'}}>
          You are
            over the age of 18.</p>
        </li><li><p lang="en-GB" className="western" align="JUSTIFY" style={{marginBottom: '0in', background: '#ffffff', display: 'inline'}}>
          You
          will not upload, post or otherwise transmit any unsolicited or
          unauthorised advertising, promotional materials, junk mail, spam,
          chain letters, pyramid schemes or any other form of solicitation
          (commercial or otherwise) through the Website.</p>
        </li><li><p lang="en-GB" className="western" align="JUSTIFY" style={{marginBottom: '0in', background: '#ffffff', display: 'inline'}}>
          You will
            not post or provide any inappropriate, offensive, racist, hateful,
            sexist, pornographic, false, misleading, incorrect, infringing,
            defamatory or libellous content or information.</p>
        </li><li><p lang="en-GB" className="western" align="JUSTIFY" style={{marginBottom: '0in', background: '#ffffff', display: 'inline'}}>
          You will
            not copy, modify, reverse engineer, reproduce, distribute, publicly
            display, publicly perform, communicate to the public, create
            derivative works from, deface, tarnish, mutilate, hack, interfere
            with, or otherwise use and exploit any Workshops except as permitted
            by these Terms or the relevant Provider as applicable.</p>
        </li><li><p lang="en-GB" className="western" align="JUSTIFY" style={{marginBottom: '0in', background: '#ffffff', display: 'inline'}}>
          You will
            not impersonate another person or gain unauthorized access to
            another person's account.</p>
        </li><li><p lang="en-GB" className="western" align="JUSTIFY" style={{marginBottom: '0in', background: '#ffffff', display: 'inline'}}>
          You will
            not introduce any virus, worm, spyware or any other computer code,
            file or program that may or is intended to damage or hijack the
            operation of any hardware, software or telecommunications equipment,
            or any other aspect of the Website or operation thereof; scrape,
            spider, use a robot or other automated means of any kind to access
            the Website.</p>
        </li><li><p lang="en-GB" className="western" align="JUSTIFY" style={{marginBottom: '0in', background: '#ffffff', display: 'inline'}}>
          You will
            not disclose any personal information to a Provider, and otherwise
            will assume responsibility for controlling how your personal
            information is disclosed or used, including, without limitation,
            taking appropriate steps to protect such information.</p>
        </li><li><p lang="en-GB" className="western" align="JUSTIFY" style={{marginBottom: '0.19in', background: '#ffffff', display: 'inline'}}>
          You will
            not solicit personal information from any Provider or other Trainee.</p>
        </li>
        </ol>


        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.11in', background: '#ffffff'}}>
          <font color="#232c3b"><font face="Helvetica, sans-serif">Trainees
            understand and agree that Providers from whom Trainees may have
            purchased Workshop(s) may choose to terminate their accounts with
            TherapyHub Ltd and become inactive. TherapyHub Ltd does not guarantee
            Provider availability to Trainees and shall not be held liable for
            any issues relating to Provider availability.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <br />
        </p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <strong><font color="#1a1a1a"><font face="Helvetica, sans-serif">3.
            CHANGES TO THESE TERMS OF SERVICE</font></font></strong></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">3.1 We
            reserve the right to modify or terminate any Website offered through
            this Website from time to time, for any reason and without notice,
            and without liability to you, to any of our clients or to any other
            third party. We reserve the right to change the content,
            presentation, performance, user facilities and/or availability of any
            part of this Website including these Terms of Service at our sole
            discretion from time to time.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">3.2 We will
            endeavour to bring any material changes to these Terms of Service to
            your attention. If we do amend these Terms of Service, the amended
            terms will be effective when posted on our website. You, the user,
            are responsible for regularly reviewing these Terms of Service and
            any additional terms posted on our Website. By continuing to access
            or use the Website after any changes become effective, you agree to
            be bound by the revised Terms of Service. If you do not agree to the
            new terms, please stop using the Website.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <strong><font color="#1a1a1a"><font face="Helvetica, sans-serif">4.
            USE OF THE WEBSITE</font></font></strong></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">4.1 You do
            not have to register to access content on the Website. However,
            TherapyHub Ltd may require you to register to access certain areas of
            our Website. You must complete the registration process and all the
            information supplied must be complete and accurate. You will be asked
            to choose a password, and the responsibility for maintaining the
            privacy of this account and the password to access it is entirely
            yours. No compensation will be made to you for the set-up or
            operation of your account.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">4.2 You
            agree not to use the account or password of another user at any time
            or to disclose your password to any third party.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">4.3 You
            agree to notify TherapyHub Ltd immediately if you suspect any
            unauthorised use of your account or access to your password or any
            other breach of the security of your account or to the security of
            our Website.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">4.4 You are
            responsible for maintaining the confidentiality of your password and
            account and you are solely and fully responsible for all activities
            that occur under your password or account. You are prohibited from
            selling, trading or otherwise transferring your TherapyHub.ie account
            to another party. TherapyHub Ltd cannot and will not be liable for
            any loss or damage arising from your failure to comply with this
            obligation.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">4.5 Once set
            up, your account will continue indefinitely, regardless of usage
            levels, unless terminated either by you or by us. You can terminate
            your account by contacting TherapyHub Ltd in writing
            at&nbsp;</font></font><strong><font color="#1a1a1a"><font face="Helvetica, sans-serif">support@therapyacademy.ie.</font></font></strong></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">4.6
            TherapyHub Ltd reserve the right to suspend or terminate your account
            without prior notice at our discretion, in accordance with paragraph
            11 hereunder, where we suspect that you have fraudulently or
            otherwise obtained access to our Website by breaching these Terms of
            Service, or any paragraph or sub- paragraph thereof.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <strong><font color="#1a1a1a"><font face="Helvetica, sans-serif">5.
            WEBSITE PURPOSE</font></font></strong></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">5.1 Our
            Website supports an online platform for further learning in the area
            of mental health</font></font><font color="#1a1a1a"><font face="Helvetica, sans-serif"><b>
        </b></font></font>
        </p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">5.2 We do
            not make any warranty, either express or implied, as to the veracity
            or accuracy of any of the information available on our Website. You
            expressly agree that any such use of any or all of the information
            that you obtain from our Website, is done at entirely your own risk
            and that you will not seek to be indemnified by us for any loss,
            howsoever caused, to you or to your employees, agents or patients,
            arising out of the usage made of any information that you, the user,
            obtain from our Website.&nbsp;</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.11in', background: '#ffffff'}}>
          <font color="#232c3b"><font face="Helvetica, sans-serif">5.3 If you
            elect to access or use our Website that involves payment of a fee,
            then you agree to pay, and will be responsible for payment of, that
            fee and all taxes associated with such access or use. If you provide
            credit card information to pay for such fees then you hereby
            represent and warrant that you are authorised to supply such
            information and hereby authorize TherapyHub Ltd to charge your credit
            card to pay the fees as they are due.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.11in', background: '#ffffff'}}>
          <font color="#232c3b"><font face="Helvetica, sans-serif">If your
            payment method fails then we may collect fees owed using other
            collection mechanisms. We may also block your access to any Workshop
            pending resolution of any amounts due by you to TherapyHub Ltd.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.11in', background: '#ffffff'}}>
          <font color="#232c3b"><font face="Helvetica, sans-serif">5.4 The
            Website is only a marketplace for Providers and Trainees. We do not
            hire or employ Providers nor are we responsible or liable for any
            interactions involved between the Providers and the Trainees who
            purchase a Workshop via the Website. We are not responsible for
            disputes, claims, losses, injuries, or damage of any kind that might
            arise out of or relate to conduct of Providers or Trainees,
            including, but not limited to, any Trainee's reliance upon any
            information provided by a Provider.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <strong><font color="#1a1a1a"><font face="Helvetica, sans-serif">6.
            CONTENT POLICY</font></font></strong></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">6.1 The
            internet website available at the
            domain&nbsp;</font></font><font color="#0000ff"><u><a href="http://www.therapyacademy.ie/"><font face="Helvetica, sans-serif">http://www.therapyacademy.ie</font></a></u></font><font color="#1a1a1a"><font face="Helvetica, sans-serif">&nbsp;acts
          as a passive conduit for the online publication and distribution of
          information and other forms of content submitted through the Website
          or obtained by us from public or other sources, and we have no
          obligation to screen content or information in advance, nor are we
          responsible for screening or monitoring material posted by you or any
          other user.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">6.2
            Information on our website is posted in good faith and updated
            regularly, but we cannot guarantee its completeness and accuracy. We
            cannot and have not checked the accuracy of all information available
            on our website.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">6.3 You are
            solely responsible for the content and information you provide to us
            to be published on the Website, either through our online data entry
            forms or other means by which you may opt to provide information to
            us. We reserve the right to edit or remove your content if we suspect
            it is untrue or that it may incur liability for us.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <strong><font color="#1a1a1a"><font face="Helvetica, sans-serif">7.
            AGE AND RESPONSIBILITY</font></font></strong></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">7.1 Our
            Website may only be used by individuals who are of the requisite
            legal capacity to be bound by these Terms of Service. Each time you
            access our Website you are representing to TherapyHub Ltd that you
            are at least 18 years of age.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <strong><font color="#1a1a1a"><font face="Helvetica, sans-serif">8.
            PRIVACY AND DATA PROTECTION</font></font></strong></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">8.1 In
            accordance with the Therapy Academy Privacy Policy, TherapyHub Ltd
            respects your privacy.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">8.2 We
            endeavour at all times to protect your privacy and the privacy of the
            other users who access the Website and use its facilities in
            accordance with obligations laid down in Irish law. For full details
            of the manner in which we use the information provided by you, the
            type of information we collect and the manner in which cookies are
            used on our website, and for further details concerning the
            circumstances upon which we disclose information, please read the
            Privacy Statement which is hereby incorporated into, and forms part
            of, these Terms of Service. The TherapyAcademy Privacy Policy can be
            found&nbsp;</font></font><font color="#0000ff"><a href="https://therapyacademy.ie/privacypolicy"><font color="#009788"><font face="Helvetica, sans-serif"><span style={{textDecoration: 'none'}}>here</span></font></font></a></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">8.3 You may
            from time-to time receive information from our partners and/or
            carefully selected third parties. You can opt out of this
            informational service at any stage and still remain a registered
            member of our Website.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">8.4 Our
            website is hosted in Ireland. Further information on your data
            privacy rights are available on the internet website of the Irish
            Data Protection Commissioner at&nbsp;</font></font><font color="#0000ff"><a href="http://www.dataprotection.ie/"><font color="#009788"><font face="Helvetica, sans-serif"><span style={{textDecoration: 'none'}}>http://www.dataprotection.ie</span></font></font></a></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">8.5
            TherapyHub Ltd holds data in accordance with the provisions of the
            Data Protection Acts 1988 and 2003, and will adhere to any other
            relevant future legislation in this area. Under this legislation, you
            the user can obtain a copy of all information which TherapyHub Ltd
            has on its database in relation to use. Members wishing to obtain
            such information should contact us in writing at the following email
            address:&nbsp;support@therapyacademy.ie</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">8.6 Our
            Website contains links to other external websites. We are not
            responsible for the privacy practices or the content of such external
            websites, and we do not make any warranties in this regard, either
            express or implied.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">8.7
            Information sent over the internet cannot be guaranteed to be
            completely secure as it is subject to possible interception, or loss,
            or possible alteration. You understand and agree to assume the
            security risk for any and all information you provide using the
            Website, including but not limited to information relating to any
            financial transaction that may be conducted between you and us in the
            course of our business or any electronic patient referral initiated
            by you. Please notify us immediately of any compromise or
            unauthorised use of your account.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">8.8 We are
            not responsible for any information sent over the internet and we
            will not be liable to you or any other party for any loss or damage,
            howsoever caused, or any other loss whatsoever, incurred in
            connection with any information sent by you to us or any information
            sent by us or by any third party to you, either through the medium of
            our website, or otherwise over the internet.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <strong><font color="#1a1a1a"><font face="Helvetica, sans-serif">9.
            SUSPENSION/TERMINATION</font></font></strong></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">9.1 Whilst
            we will make reasonable attempts to inform you, provided that we deem
            it to be in our mutual interest to do so, we may at any time, without
            notice to you, suspend or terminate your access to our Website, or
            any service forming part of our Website, wholly or partially, for any
            reason including, but without limitation, where you have provided
            false or misleading information to us, or you are in breach of our
            Terms of Service, or if we cannot verify or authenticate any
            information submitted by you, or purported to have been submitted by
            you or on your behalf, to our Website.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">9.2 We shall
            not be liable to you or any third party for any suspension or
            termination of access to our Website, which includes any resulting
            damage that may allegedly arise to you, your employees or your
            agents, howsoever caused.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <strong><font color="#1a1a1a"><font face="Helvetica, sans-serif">10.
            USE OF OUR WEBSITE</font></font></strong></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">10.1 You
            agree not to use this Website or any of the facilities and/or Website
            provided by us for any purpose that is fraudulent, unlawful or
            prohibited by these Terms of Service, or otherwise in accordance with
            law. In particular, you agree&nbsp;</font></font><strong><font color="#1a1a1a"><font face="Helvetica, sans-serif">NOT</font></font></strong><font color="#1a1a1a"><font face="Helvetica, sans-serif">&nbsp;to
          use therapyacademy.ie to:</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">10.1.1 post
            illegal Material;</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">10.1.2
            defame, abuse, harass, stalk, threaten or otherwise violate the
            rights (such as rights of privacy and publicity) of others;</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">10.1.3
            solicit personal information from anyone under 18;</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">10.1.4
            solicit passwords or personally identifying information for
            commercial or unlawful purposes;</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">10.1.5
            collect or store other users' personal data for purposes other than
            establishing contact that is reasonably expected to be welcomed by
            such other users;</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">10.1.6
            attempt to gain unauthorised access to the therapyacademy.ie
            administrative areas or interface, to user accounts, computer systems
            or networks connected to the therapyacademy.ie site, through password
            mining or any other means;</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">10.1.7 post
            irrelevant material, repeatedly post the same or similar material or
            otherwise impose an unreasonable or disproportionately large load on
            the therapyacademy.ie servers or infrastructure;</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">10.1.8 post
            any unsolicited or unauthorised advertising, promotional content,
            'junk mail', 'spam', 'chain letters', 'pyramid schemes', or any other
            form of commercial publicity;</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">10.1.9 post
            any abusive, harmful, vulgar, obscene, sexually explicit, indecent,
            profane, inappropriate, or racially, ethnically or otherwise
            objectionable material;</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">10.2.0 post
            material that contains violence, or offensive subject matter or
            contains a link to an adult website;</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">10.2.1 post
            material that promotes or encourages illegal activity;</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">10.2.2 post
            material that infringes any patent, trademark, trade secret,
            copyright, rights of privacy or publicity, or other proprietary right
            of any party;</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">10.2.3 post
            material that falsely expresses or implies that such material is
            sponsored or endorsed by Us;</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">10.2.4 post
            material that contains software viruses or harmful programmes
            including but not limited to, Trojan horses, worms, time bombs,
            cancel-bots, computer code, files or programs designed to interrupt,
            destroy or limit the functionality of any computer software or
            hardware or telecommunications equipment;</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">10.2.5
            modify, adapt, translate, or reverse engineer any portion of
            therapyacademy.ie, or use any robot, spider, site search/retrieval
            application, or other device to retrieve or index any portion of
            therapyacademy.ie, except as expressly authorised in writing by
            therapyacademy.ie;</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">10.2.6
            reformat or frame any portion of the web pages that are part of
            therapyacademy.ie.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">10.3 The
            information contained on our Website may contain technical
            inaccuracies and typographical errors. We will endeavour to remedy
            such errors where they are brought to our attention, but to maximum
            extent permitted by law, we shall not accept any responsibility or
            any liability for our failure to do so.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">10.4 The
            information on our Website may be updated from time to time but we do
            not accept any responsibility for keeping the information in these
            pages up-to-date nor any liability for our failure to do so.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">10.5 We
            reserve the right, at our sole discretion, to pursue all of our legal
            remedies upon breach by you of these Terms of Service, including but
            not limited to removal of your postings and content from our Website,
            and restricting or otherwise suspending your ability to access to our
            Website and to use any or all of its constituent Website.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <strong><font color="#1a1a1a"><font face="Helvetica, sans-serif">11.
            COPYRIGHT NOTICE AND LIMITED LICENCE</font></font></strong></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">11.1 The
            information, content, graphics, text, sounds, images, buttons,
            trademarks, service marks, get-up, business names, domain names,
            rights in good will, know-how, designs and rights in designs, trade
            names and logos (whether registered or unregistered) contained on our
            Website are protected by copyright, trade mark, database right,&nbsp;</font></font><em><font color="#1a1a1a"><font face="Helvetica, sans-serif">sui
          generis</font></font></em><font color="#1a1a1a"><font face="Helvetica, sans-serif">&nbsp;right
          and other intellectual property laws and are also protected under
          national laws and international treaties. TherapyHub Ltd and/or its
          licensors (as the case may be) retain all right, title, interest and
          intellectual property rights in and to the Materials. All proprietary
          content on our website is the copyright of TherapyHub Ltd or third
          parties.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">11.2 Any
            other use of the information on our Website, including any form of
            copying or reproduction, modification, distribution, uploading,
            re-publication, extraction, re-utilisation, incorporation or
            integration with other Materials or works or re-delivery using
            framing technology, without our prior permission is strictly
            prohibited and is a violation of the proprietary rights of TherapyHub
            Ltd. Other than as expressly provided herein, nothing in these Terms
            of Service should be construed as conferring, by implication or
            otherwise, any licence or right under any copyright, patent, trade
            mark, database right,&nbsp;</font></font><em><font color="#1a1a1a"><font face="Helvetica, sans-serif">sui
          generis</font></font></em><font color="#1a1a1a"><font face="Helvetica, sans-serif">&nbsp;right
          or other intellectual property or proprietary interest of TherapyHub
          Ltd , its licensors or any third party.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">11.3 You
            agree to grant TherapyHub Ltd a non-exclusive, royalty free,
            world-wide, transferable perpetual licence with the right to
            sub-licence, reproduce, distribute, transmit, create derivative works
            of, or publicly display any or all content or information (including
            without limitation, any or all ideas contained therein for new or
            improved Website) when you submit information or any other content to
            our Website either during the registration process or to us, by
            whatever means, thereafter.</font></font></p>
        <h2 lang="en-GB" className="western" align="JUSTIFY" style={{marginTop: '0.22in', marginBottom: '0.11in', background: '#ffffff'}}>
          <font color="#232c3b"><font face="Helvetica, sans-serif"><font size={4}><span style={{fontWeight: 'normal'}}>12.
                  Pricing &amp; Payment</span></font></font></font></h2>
        <h3 lang="en-GB" className="western" align="JUSTIFY" style={{marginTop: '0.22in', marginBottom: '0.11in', background: '#ffffff', fontWeight: 'normal'}}>
          <font color="#232c3b"><font face="Helvetica, sans-serif">12.1.
            Pricing:</font></font></h3>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.11in', background: '#ffffff'}}>
          <font color="#232c3b"><font face="Helvetica, sans-serif"><font size={3} style={{fontSize: '11pt'}}>Pricing
            of Therapy Academy Workshops is determined in accordance with the
            terms set forth in the&nbsp;</font></font></font><font color="#0000ff"><u><a href="https://www.udemy.com/terms/instructor/"><font color="#08809c"><font face="Helvetica, sans-serif"><font size={3} style={{fontSize: '11pt'}}>Provider
          Terms</font></font></font></a></u></font><font color="#232c3b"><font face="Helvetica, sans-serif"><font size={3} style={{fontSize: '11pt'}}>.
          If you are a Trainee, you agree to pay the fees for Workshops that
          you purchase, and hereby authorise us to charge your credit card for
          such fees. If your credit card is declined, you agree to pay us the
          fees within thirty (30) days of notification from us, and pay (at our
          discretion) a late payment charge of 1% per month, or the maximum
          permitted by law, whichever is greater.</font></font></font></p>
        <h3 lang="en-GB" className="western" align="JUSTIFY" style={{marginTop: '0.22in', marginBottom: '0.11in', background: '#ffffff', fontWeight: 'normal'}}>
          <font color="#232c3b"><font face="Helvetica, sans-serif">12.2.
            Payment:</font></font></h3>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.11in', background: '#ffffff'}}>
          <font color="#232c3b"><font face="Helvetica, sans-serif"><font size={3} style={{fontSize: '11pt'}}>All
            payments are made to TherapyHub Ltd. By purchasing Workshops (e.g.
            clicking or tapping the relevant purchase button), you are confirming
            that you want the Workshop immediately credited to your account and
            that by doing so you are hereby waiving any and all cancellation
            rights under applicable laws and/or any national laws implementing
            it. </font></font></font>
        </p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <strong><font color="#1a1a1a"><font face="Helvetica, sans-serif">13.
            DISCLAIMERS</font></font></strong></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">13.1 THE
            WEBSITE IS AVAILABLE TO ALL USERS "AS IS" AND, TO THE
            GREATEST EXTENT PERMITTED BY LAW, THE WEBSITE IS MADE AVAILABLE
            WITHOUT ANY REPRESENTATIONS OR WARRANTIES OF ANY KIND, EITHER EXPRESS
            OR IMPLIED.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">13.2
            THERAPYHUB LTD MAKES NO REPRESENTATIONS, WARRANTIES OR UNDERTAKINGS
            ABOUT THE WEBSITE OR INFORMATION AVAILABLE ON THE WEBSITE, INCLUDING
            WITHOUT LIMITATION, THEIR MERCHANTABILITY, QUALITY OR FITNESS FOR A
            PARTICULAR PURPOSE.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">13.3 ALL
            INFORMATION PROVIDED ON OUR WEBSITE IS INTENDED AS A GUIDE ONLY AND
            SHOULD NOT BE CONSTRUED AS A SUBSTITUTE FOR PROFESSIONAL MEDICAL
            ADVICE AND NEITHER THERAPYHUB LTD, NOR ITS OFFICERS, DIRECTORS,
            EMPLOYEES OR AGENTS MAKE ANY REPRESENTATIONS, WARRANTIES OR
            UNDERTAKINGS AS TO THE ACCURACY OF ANY INFORMATION PROVIDED ON OUR
            WEBSITE.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">13.4
            THERAPYHUB LTD MAKES NO REPRESENTATIONS, WARRANTIES OR UNDERTAKINGS
            THAT OUR WEBSITE, OR THE SERVER(S) UPON WHICH IT IS HOSTED, WILL BE
            FREE FROM DEFECTS, INCLUDING, BUT NOT LIMITED TO VIRUSES OR OTHER
            HARMFUL ELEMENTS. TO THE MAXIMUM EXTENT PERMITTED BY LAW, THERAPYHUB
            LTD ACCEPTS NO LIABILITY FOR ANY INFECTION BY COMPUTER VIRUS, BUG,
            TAMPERING, UNAUTHORISED ACCESS, INTERVENTION, ALTERATION OR USE,
            FRAUD, THEFT, TECHNICAL FAILURE, ERROR, OMISSION, INTERRUPTION,
            DELETION, DEFECT, DELAY, OR ANY EVENT OR OCCURRENCE BEYOND THE
            CONTROL OF THERAPYHUB LTD, WHICH CORRUPTS OR AFFECTS THE
            ADMINISTRATION, SECURITY, FAIRNESS AND THE INTEGRITY OR PROPER
            CONDUCT OF ANY ASPECT OF OUR WEBSITE.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">13.5 ALL USE
            BY YOU OF OUR WEBSITE IS AT YOUR OWN RISK. YOU ASSUME COMPLETE
            RESPONSIBILITY FOR, AND FOR ALL RISK OF LOSS RESULTING FROM YOUR
            DOWNLOADING ,OR USING OF, OR REFERRING TO, OR RELYING ON, THE
            FACILITIES, SERVICE(S) OR INFORMATION PROVIDED ON OUR WEBSITE, OR ANY
            OTHER INFORMATION OBTAINED BY YOU THROUGH YOUR USE OF OUR WEBSITE.
            YOU AGREE THAT, TO THE MAXIMUM EXTENT PERMITTED BY LAW, THERAPYHUB
            LTD AND ALL CONNECTED PROVIDERS OF TELECOMMUNICATIONS AND NETWORK
            WEBSITE AND INFRASTRUCTURE TO THERAPYHUB LTD WILL NOT BE LIABLE FOR
            DAMAGES ARISING OUT OF YOUR USE OR YOUR INABILITY TO USE THE WEBSITE,
            AND YOU HEREBY WAIVE ANY AND ALL CLAIMS WITH RESPECT THERETO, WHETHER
            BASED ON CONTRACT, TORT OR OTHER GROUNDS.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">13.6 NO ORAL
            ADVICE OR WRITTEN INFORMATION, GIVEN BY THERAPYHUB LTD, ITS OFFICERS,
            AGENTS, DIRECTORS, EMPLOYEES OR AGENTS, OR THE LIKE, SHALL CREATE A
            WARRANTY, NOR SHALL YOU RELY ON ANY SUCH INFORMATION OR ADVICE.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">13.7
            THERAPYHUB LTD CANNOT GUARANTEE, AND DOES NOT PROMISE, ANY SPECIFIC
            RESULTS FROM THE USE BY YOU OF OUR WEBSITE.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">13.8 PART OF
            OUR WEBSITE MAY CONTAIN THIRD-PARTY ADVERTISING. ADVERTISERS ARE
            RESPONSIBLE FOR ENSURING THAT MATERIAL SUBMITTED FOR INCLUSION ON OUR
            WEBSITE COMPLIES WITH ALL RELEVANT IRISH, EUROPEAN AND INTERNATIONAL
            LAWS AND ALL RELEVANT IRISH, EUROPEAN AND INTERNATIONAL INDUSTRY
            CODES OF PRACTICE AND INDUSTRY OR VOLUNTARY CODES OF CONDUCT, WHERE
            APPROPRIATE. THERAPYHUB LTD TAKES NO RESPONSIBILITY FOR THIRD PARTY
            ADVERTISEMENTS WHICH ARE HOSTED ON OUR WEBSITE OR MADE AVAILABLE TO
            YOU THROUGH ANY THERAPYHUB-RELATED SERVICE, NOR DO WE TAKE ANY
            RESPONSIBILITY FOR THE GOODS OR WEBSITE OFFERED BY SUCH THIRD PARTY
            ADVERTISERS. THERAPYHUB LTD WILL NOT BE RESPONSIBLE FOR ANY ERROR OR
            INACCURACY IN ADVERTISING MATERIALS, NOR WILL IT BE LIABLE FOR ANY
            BREACH OF IRISH, EUROPEAN OR OTHER INTERNATIONAL LAWS, NOR ANY IRISH,
            EUROPEAN OR OTHER INTERNATIONAL INDUSTRY CODES OF PRACTICE OR
            VOLUNTARY CODE OF CONDUCT BY THIRD PARTY ADVERTISERS IN RELATION TO
            THE CONTENT OF ANY OF THEIR ADVERTISEMENTS WHICH MAY FROM TIME TO
            TIME APPEAR ON OUR WEBSITE.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <strong><font color="#1a1a1a"><font face="Helvetica, sans-serif">14.
            LIMITATION OF LIABILITY</font></font></strong></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">14.1 TO THE FULLEST EXTENT
            PERMITTED BY APPLICABLE LAW, NEITHER THERAPYHUB LTD NOR ANY OF ITS
            OFFICERS, DIRECTORS, EMPLOYEES, AGENTS OR OTHER REPRESENTATIVES WILL
            BE LIABLE FOR ANY LOSS OR DAMAGE ARISING OUT OF, OR IN CONNECTION WITH,
            YOUR USE OF ANY FACILITIES OR WEBSITE WHICH WE OFFER ON OUR, OR ANY TRANSACTIONS
            ENTERED INTO, THROUGH OR FROM OUT WEBSITE, INCLUDING, BUT NOT LIMITED TO, DIRECT,
            INDIRECT OR CONSEQUENTIAL LOSS OR DAMAGES, LOSS OF DATA, LOSS OF INCOME,
            PROFIT OR OPPORTUNITY, LOSS OF, OR DAMAGE TO, PROPERTY AND CLAIMS OF THIRD
            PARTIES, EVEN IF THERAPYHUB LTD HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH LOSS
            OR DAMAGES, OR SUCH LOSS OR DAMAGES WERE REASONABLY FORESEEABLE.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">14.2 IN NO EVENT SHALL THERAPYHUB
            LTD NOR ANY OF ITS OFFICERS, DIRECTORS, EMPLOYEES, AGENTS OR OTHER REPRESENTATIVES
            BE LIABLE FOR ANY DAMAGES WHATSOEVER RESULTING FROM THE STATEMENTS
            OR CONDUCT OF THIRD PARTIES OR THE INTERRUPTION, SUSPENSION OR TERMINATION
            OF THE WEBSITE WEBSITE, WHETHER SUCH INTERRUPTION, SUSPENSION OR TERMINATION
            WAS JUSTIFIED OR NOT, NEGLIGENT OR INTENTIONAL, INADVERTENT OR ADVERTENT.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">14.3 WITHOUT
            LIMITATION TO THE FOREGOING, UNDER NO CIRCUMSTANCES SHALL THERAPYHUB
            LTD NOR ANY OF ITS OFFICERS, DIRECTORS, EMPLOYEES, AGENTS OR OTHER
            REPRESENTATIVES BE HELD LIABLE FOR ANY DELAY OR FAILURE IN
            PERFORMANCE OF OUR WEBSITE OR THE FACILITIES OR WEBSITE THAT WE OFFER
            ON OUR WEBSITE, RESULTING DIRECTLY OR INDIRECTLY FROM ACTS OF NATURE,
            FORCES OR CAUSES BEYOND THEIR REASONABLE CONTROL, INCLUDING, WITHOUT
            LIMITATION, INTERNET FAILURE, COMPUTER EQUIPMENT FAILURES,
            TELECOMMUNICATION FAILURES, OTHER EQUIPMENT FAILURES, ELECTRICAL
            POWER FAILURES, STRIKES, LAY-WAY DISPUTES, RIOTS, INTERACTIONS, CIVIL
            DISTURBANCES, SHORTAGES OF LABOUR OR MATERIALS, FIRES, FLOATS,
            STORMS, EXPLOSIONS, ACTS OF GOD, WAR, GOVERNMENTAL ACTIONS, ORDERS OF
            DOMESTIC OR FOREIGN COURTS OR TRIBUNALS OR THE NON-PERFORMANCE OF A
            THIRD PARTY.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">14.4
            THERAPYHUB LTD DOES NOT EXCLUDE LIABILITY FOR DEATH OR PERSONAL
            INJURY CAUSED BY ITS NEGLIGENCE OR THAT OF ITS EMPLOYEES OR
            AUTHORISED REPRESENTATIVES OR FOR FRAUD.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <strong><font color="#1a1a1a"><font face="Helvetica, sans-serif">15.
            INDEMNITY</font></font></strong></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">15.1 You
            agree to defend, indemnify and keep indemnified and hold TherapyHub
            Ltd and (as applicable) its officers, directors, employees, agents or
            other representatives, harmless against any and all claims,
            proceedings, actions, costs (including legal costs), charges,
            expenses, damages, liability, losses and demands made by, or
            liabilities to, any third party, resulting from any activities
            conducted under your account and/or your email/username and/or
            password, resulting in the use or misuse of our Website, including
            but not limited to posting content on our Website, infringing any
            third party intellectual property or other rights, or otherwise
            arising out of your breach or any breach of these Terms of Service.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <strong><font color="#1a1a1a"><font face="Helvetica, sans-serif">16.
            LINKS TO THIRD PARTY WEBSITES</font></font></strong></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">16.1 Our
            Website contains links to third party websites. Your use of third
            party websites is subject to the independent terms and conditions of
            use contained within each of those websites. Access to any other
            external websites through our Website is at your own risk.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">16.2
            TherapyHub Ltd is not responsible or liable for the accuracy of any
            information, data, opinions or statements made on third party
            websites, or the security of any link or communication with those
            websites. TherapyHub Ltd reserves the right to terminate a link to a
            third party website at any time.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">16.3 The
            fact that TherapyHub Ltd provides a link to a third party website
            does not mean that TherapyHub Ltd endorses, authorises or sponsors
            that website, nor does it mean that TherapyHub Ltd is affiliated with
            any third party websites, owners or sponsors. TherapyHub Ltd provides
            these links merely as a convenience for those who use our Website.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <strong><font color="#1a1a1a"><font face="Helvetica, sans-serif">17.
            REFUND POLICY</font></font></strong></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">17.1 No
            contract will subsist between you and TherapyHub Ltd for a sale to
            you of any service, unless and until TherapyHub Ltd accepts your
            order by confirming that your payment has been received by us or our
            agents. That acceptance will be deemed complete and will be deemed
            for all purposes to have been effectively communicated to you at the
            time TherapyHub Ltd sends the e-mail to you (whether or not you
            receive that e-mail).</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">17.2
            TherapyHub Ltd does not issue refunds for any paid Workshop. If you
            have any query in relation to this, you agree to submit such query in
            writing to TherapyHub Ltd. Submission of such a query does not imply
            any direct action be taken by TherapyHub Ltd with respect to such
            query or queries, but TherapyHub Ltd will endeavour to respond in a
            timely fashion. Failure to provide timely payment for any paid
            service offered by TherapyHub Ltd may result in our terminating such
            service, without notice, and entirely at our own discretion.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">17.3
            Notwithstanding any of the other sub-paragraphs contained in this
            section, your statutory rights are not affected.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <strong><font color="#1a1a1a"><font face="Helvetica, sans-serif">18.
            AVAILABILITY</font></font></strong></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">18.1
            Although TherapyHub Ltd endeavours to ensure that our Website is
            available at all times, there may be occasions when access to our
            Website may be interrupted, e.g. to allow maintenance, upgrades and
            emergency repairs to take place, or due to the failure of
            telecommunications links and equipment that are beyond our control.
            You agree that TherapyHub Ltd shall not be liable to you for any loss
            incurred by you resulting from the modification, suspension or
            discontinuance of our Website.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">18.2 You
            accept that you have sole responsibility for adequate protection and
            back up of any content and data you submit to the Website and for
            undertaking reasonable and appropriate precautions to scan for
            computer viruses or other destructive items.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <strong><font color="#1a1a1a"><font face="Helvetica, sans-serif">19
            JURISDICTION AND GOVERNING LAW</font></font></strong></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">19.1 This
            Website is controlled and operated by TherapyHub Ltd and its service
            provider(s) from Ireland. TherapyHub.ie does not make any
            representation that the facilities, Website and information contained
            thereon, including but not limited to the availability of advertising
            material relating to third party products or Website, offered through
            our Website is appropriate or suitable for use in any country other
            than Ireland, or that such information complies with any legal or
            regulatory requirements in any jurisdiction other than Ireland.. In
            accessing our Website, you do so at your own risk and on your own
            initiative, and are responsible for compliance with local laws, to
            the extent that any local laws are applicable.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">19.2 If it
            is prohibited to make our Website, facilities, Website or information
            offered through our Website, including but not limited to the
            availability of advertising material relating to third party products
            and or Website, or any part of them available to your in your country
            of access, (whether by reason of nationality, residence, law or
            otherwise), this Website, the facilities, Website and/or information
            and/or advertising material relating to third party products and or
            Website offered through our Website, or any part of them, are hereby
            regarded at not directed at you.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">19.3 These
            Terms of Service shall be governed by and construed in accordance
            with the laws of Ireland, and you hereby agree for the benefit of
            TherapyHub Ltd , and without prejudice to the right of TherapyHub Ltd
            to take proceedings in relation to these Terms of Service before any
            court of competent jurisdiction, that the courts of the Republic of
            Ireland shall have exclusive jurisdiction to hear and determine any
            actions or proceedings that may arise out of, or in connection with,
            these Terms of Service. You also hereby agree that for such purposes
            you irrevocably submit to the jurisdiction of the courts of the
            Republic of Ireland.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">19.4 The
            language of any dispute resolution procedure or any proceedings under
            these Terms of Service will be English.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <strong><font color="#1a1a1a"><font face="Helvetica, sans-serif">20.
            MISCELLANEOUS</font></font></strong></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">20.1 Any
            waiver of any provision of these Terms of Service must be in writing
            and signed by an authorised officer of TherapyHub Ltd to be valid.
            Any waiver of any provision hereunder shall not operate as a waiver
            of any other provision, or a continuing waiver of any provision in
            the future.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">20.2 Each of
            the provisions of these Terms of Service is separate and severable
            and enforceable accordingly, and if at any time any provision is
            judged by any court of competent jurisdiction to be void or
            unenforceable the validity, legality and enforceability of the
            remaining provisions shall not in any way be affected or impaired.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">20.3 Nothing
            in these Terms of Service shall constitute, or be deemed to
            constitute, a partnership between you and TherapyHub Ltd or its
            agents, nor shall either party be deemed to be the agent of the other
            party.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">20.4 These
            Terms of Service represent the entire understanding and agreement
            between you and TherapyHub Ltd relating to your use of our Website,
            its facilities Website and information available thereon and
            supersede any and all prior statements, understandings and
            agreements.</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <strong><font color="#1a1a1a"><font face="Helvetica, sans-serif">21.
            CONTACTING US</font></font></strong></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#1a1a1a"><font face="Helvetica, sans-serif">21.1 If you
            have any questions about these Terms of Service, please feel free to
            contact us through our&nbsp;support@therapyacademy.ie&nbsp;email
            address or write to us at:</font></font></p>
        <p lang="en-GB" align="JUSTIFY" style={{marginBottom: '0.21in', background: '#ffffff'}}>
          <font color="#232c3b"><font face="Helvetica, sans-serif">TherapyHub
            Ltd, Portland, Lorrha, Nenagh, Co. Tipperary</font></font></p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/informations/TermsOfCondition.jsx